module.exports = __webpack_public_path__ + "media/images/icons/country_flags/nc-122e475dd5dabd25cc81791e82fbe844.svg";